import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Bearer fallback: preview runs inside an iframe where SameSite=None cookies
// are blocked as third-party. Attach the stored session token so auth survives.
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("lf-token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
